export const article = [
  {
    articleId: 21,
    url: "como-cambiar-tu-plan",
    category: {
      slug:"cuenta",
      name: "Mi cuenta"
    },
    title: "Cómo cambiar tu plan ",
    content: 
      <>
        <div className="row">
          <p>Puedes cambiar tu plan de Mega GO en cualquier momento si sigues estos pasos:</p>
        </div>
        <div className="">
          <div className="accordeonContent">
            <ul className="decimal">
              <li>Inicia sesión en tu cuenta de Mega GO.</li>
              <li>En el ícono “Perfil”, en Información de mi plan, selecciona Cambiar plan. (Si no encuentras la opción para cambiar de plan, comunícate con nosotros.)</li>
            </ul>
            <p>NOTA: Si tu cuenta está suspendida, no se pueden realizar cambios de plan hasta que se resuelva la suspensión.</p>
            <ul className="decimal">
              <li>Selecciona el plan deseado y, luego, selecciona Continuar o Actualizar.</li>
              <li>Selecciona Confirmar cambio o Confirmar.</li>
            </ul>
            <p>El cambio de plan al superior se aplica de inmediato para que puedas disfrutar de todas las nuevas funciones.</p> 
            <p>El cambio de plan al gratuito se aplica en la siguiente fecha de facturación. Puedes continuar usando las funciones del plan superior hasta la próxima fecha de facturación.</p>
            <p>Puedes cancelar el servicio de Mega GO en cualquier momento.</p>
          </div>
        </div>
      </>
  }
];